// extracted by mini-css-extract-plugin
export default {"root":"PendingTableHeader_root__n9Q++","heading":"PendingTableHeader_heading__tmYBl"};